import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { login } from '@/api/user';
import { jsonInBlacklist } from '@/api/jwt';
import router from '@/router/index';
export var user = {
  namespaced: true,
  state: {
    userInfo: {
      uuid: "",
      nickName: "",
      headerImg: "",
      authority: ""
    },
    token: "",
    needModifyPwd: false
  },
  mutations: {
    setUserInfo: function setUserInfo(state, userInfo) {
      // 这里的 `state` 对象是模块的局部状态
      state.userInfo = userInfo;
    },
    setToken: function setToken(state, token) {
      // 这里的 `state` 对象是模块的局部状态
      state.token = token;
    },
    needModifyPwd: function needModifyPwd(state, _needModifyPwd) {
      // 这里的 `state` 对象是模块的局部状态
      state.needModifyPwd = _needModifyPwd;
    },
    NeedInit: function NeedInit(state) {
      state.userInfo = {};
      state.token = "";
      sessionStorage.clear();
      router.push({
        name: 'init',
        replace: true
      });
    },
    LoginOut: function LoginOut(state) {
      state.userInfo = {};
      state.token = "";
      sessionStorage.clear();
      router.push({
        name: 'login',
        replace: true
      });
      // window.location.reload()
    },
    ResetUserInfo: function ResetUserInfo(state) {
      var userInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      console.log(state.userInfo);
      state.userInfo = _objectSpread(_objectSpread({}, state.userInfo), userInfo);
      console.log(state.userInfo);
    }
  },
  actions: {
    LoginIn: function LoginIn(_ref, loginInfo) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, dispatch, rootGetters, getters, res, asyncRouters;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, dispatch = _ref.dispatch, rootGetters = _ref.rootGetters, getters = _ref.getters;
              _context.next = 3;
              return login(loginInfo);
            case 3:
              res = _context.sent;
              if (!(res.code == 0)) {
                _context.next = 15;
                break;
              }
              commit('setUserInfo', res.data.user);
              commit('setToken', res.data.token);
              _context.next = 9;
              return dispatch('router/SetAsyncRouter', {}, {
                root: true
              });
            case 9:
              asyncRouters = rootGetters['router/asyncRouters'];
              router.addRoutes(asyncRouters);

              // 获取用户有权限的api
              _context.next = 13;
              return dispatch('api/getUserApis', {
                authorityId: res.data.user.authorityId
              }, {
                root: true
              });
            case 13:
              // const redirect = router.history.current.query.redirect
              // console.log(redirect)
              // if (redirect) {
              //     router.push({ path: redirect })
              // } else {
              router.push({
                name: getters["userInfo"].authority.defaultRouter
              });
              // }
              return _context.abrupt("return", true);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    LoginOut: function LoginOut(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var commit, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return jsonInBlacklist();
            case 3:
              res = _context2.sent;
              if (res.code == 0) {
                commit("LoginOut");
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  getters: {
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    token: function token(state) {
      return state.token;
    },
    needModifyPwd: function needModifyPwd(state) {
      return state.needModifyPwd;
    }
  }
};